import { render, staticRenderFns } from "./ChannelChip.vue?vue&type=template&id=5f8c0d93&"
import script from "./ChannelChip.vue?vue&type=script&lang=ts&"
export * from "./ChannelChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports